import { render, staticRenderFns } from "./FormularioContato.vue?vue&type=template&id=26122d98&scoped=true&"
import script from "./FormularioContato.vue?vue&type=script&lang=ts&"
export * from "./FormularioContato.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26122d98",
  null
  
)

export default component.exports